import { ApiBackClient } from '../../../services/apiADA';
import { saveInSessionStorage } from '../../../contexts/LocalStorage';

export function buscarPedidosERP(username, codcli, numped, sitped, tipped, token, cancelToken) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/consultapedidos", { "nomcli": codcli, "numped": numped, "sitped": sitped, "tipped": tipped },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
                cancelToken: cancelToken
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    console.error(res.data);
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function infoPedido(numPed, codEmp, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/infopedidos", { "numped": numPed, "codemp": codEmp },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    console.error(res.data);
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function buscarHistoricoPedidoERP(numPed, codEmp, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/timelinepedidos", { "numped": numPed, "codemp": codEmp },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    //console.error(res.data);
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    //console.log(res.data[0].evento);
                    resolve(res.data[0].evento);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function buscarItensPedidoERP(numPed, codEmp, username, token) {   
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/infopedidoprodutos", { "numped": numPed, "codemp": codEmp},
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    //console.error(res.data);
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    //console.log(res.data[0].evento);
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function buscarClientesERP(find, username, token, cancelToken) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/consultacliente", { "find": find },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
                cancelToken: cancelToken
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function buscarFormaPagamentoERP(codfpg, desfpg, username, token, cancelToken) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/consultaformapagamento", { "codfpg": codfpg, "desfpg": desfpg },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
                cancelToken: cancelToken
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function buscarCondicaoPagamentoERP(codcpg, descpg, username, token, cancelToken) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/consultacondpagamento", { "codcpg": codcpg, "descpg": descpg },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
                cancelToken: cancelToken
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function buscarProdutosERP(find, username, token, cancelToken) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/consultaproduto", { "find": find },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
                cancelToken: cancelToken
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function buscarDerivacoesERP(codclc, username, token, cancelToken) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/consultaderivacao", { "codpro": "", "codclc": codclc },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
                cancelToken: cancelToken
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function buscarTransportadoraERP(cod, name, username, token, cancelToken) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/transportadora", { "codtra": cod, "nomtra": name },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
                cancelToken: cancelToken
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function enviarPrePedido(pedido, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/prepedido", pedido,
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function atualizarPrePedido(pedido, id, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.put("/prepedido", pedido,
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    prepedido: id,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function atualizarResumoPrePedido(resumo, id, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.put("/resumoprepedido", resumo,
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    resumo: id,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function enviarEmailPedidos(pedidos, enviaCliente, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/email", {"pedidos": pedidos, "enviacliente": enviaCliente},
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function excluirPrePedido(id, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.delete("/prepedido",
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    prepedido: id,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function consultarPrePedido(id, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.get("/prepedido",
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    prepedido: id,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function gerarResumoPrePedido(id, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.get("/resumoprepedido",
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    prepedido: id,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function enviarPedidoERP(id, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/pedido", {} ,
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    prepedido: id,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url"),
                timeout: 240000
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function verificaSaldoPrePedido(id, username, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/saldo", {} ,
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    prepedido: id,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

function consoleLogErros(error) {
    console.log("error validação");
    console.log(error);
    if (error.response) {
        // Requisição feita e o servidor retornou um erro
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
    } else if (error.request) {
        // A requisição foi feita, mas nenhuma resposta foi recebida
        console.error(error.request);
    } else {
        // Alguma coisa aconteceu nas configurações da requisição que gerou um erro
        console.error('Error', error.message);
    }
}